import React, { useState } from 'react';
import { Menu, Input, Header, Icon } from 'semantic-ui-react';
import IconView from 'common/IconView';

const Blueprint = function(props) {
  const bp = props.blueprint;
  const col = props.selected ? 'blue' : null;
  return (
    <Menu.Item onClick={props.onClick} title={bp.ID} active={props.selected} color={col}>
      <IconView icon={bp.Icon}/>
      {bp.Name}
    </Menu.Item>
  );
}

const Blueprints = function(props) {
  const [ search, setSearch ] = useState('');
  const onClickBlueprint = (bp) => {
    props.onSelectBlueprint(bp);
  };

  const blueprints = props.blueprints.filter((bp) => bp.Name.toLowerCase().includes(search.toLowerCase()));
  const x = <Icon name='x' link onClick={() => setSearch('')} />;
  const menuProps = {...props}
  delete menuProps.blueprints;
  delete menuProps.onSelectBlueprint;
  delete menuProps.selected;

  return (
    <Menu {...menuProps}>
      <Menu.Item>
        <Header>Blueprints</Header>
      </Menu.Item>
      <Menu.Item>
        <Input icon={search.length > 0 ? x : 'search'}
               placeholder='Search...'
               value={search}
               onChange={(e,d) => setSearch(d.value)}
               label='Filter'
               labelPosition='left corner' />
      </Menu.Item>
      {blueprints.map((bp) =>
        <Blueprint selected={props.selected ? props.selected===bp.ID : false}
                   key={bp.ID}
                   onClick={() => onClickBlueprint(bp)}
                   blueprint={bp} />)}
    </Menu>
  );
}


export default Blueprints;
